import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b7acd0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Mon contrat", -1))
const _hoisted_2 = {
  key: 0,
  class: "mt-5 rounded-2 overflow-hidden d-flex flex-column bg-white px-3 py-2"
}
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cursor-pointer mt-2 p-2",
  style: {"font-size":"1.2em"}
}, " Renouveller un contrat ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cursor-pointer mb-2 p-2",
  style: {"font-size":"1.2em"}
}, " Résilier un contrat ", -1))
const _hoisted_10 = {
  key: 1,
  id: "loader-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_card_img = _resolveComponent("b-card-img")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_b_card_body = _resolveComponent("b-card-body")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_card = _resolveComponent("b-card")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, null, {
    default: _withCtx(() => [
      _hoisted_1,
      (_ctx.contract)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_b_card, {
              "no-body": "",
              class: "overflow-hidden",
              style: {}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_col, {
                      md: "3",
                      class: "d-flex justify-content-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_card_img, {
                          src: _ctx.pathImg+_ctx.contract.branch.photo,
                          alt: "Image",
                          class: "rounded-0 object-contain align-self-center",
                          style: {"height":"50%","width":"50%"}
                        }, null, 8, ["src"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_b_col, { md: "6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_card_body, {
                          title: 'Contrat N° : '+_ctx.contract.police
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_card_text, { style: {"font-size":"1.2em"} }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                  _createElementVNode("img", {
                                    src: _ctx.pathImg+_ctx.contract.insurer.photo,
                                    alt: "",
                                    style: {"width":"22%","height":"22%"},
                                    class: "img-fluid"
                                  }, null, 8, _hoisted_4)
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                  _createTextVNode("Type contrat : "),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.contract.branch.label) + " " + _toDisplayString(_ctx.contract.type), 1)
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                  _createTextVNode("Valide jusqu'au "),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.expireAt), 1)
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                  _createTextVNode("Status : "),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.status), 1)
                                ])
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["title"])
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_b_card, {
              "no-body": "",
              class: "overflow-hidden mt-3",
              style: {}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_col, {
                      md: "6",
                      class: "d-flex justify-content-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_card_body, { title: "Information" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_card_text, null, {
                              default: _withCtx(() => [
                                _hoisted_8,
                                _hoisted_9
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        })
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_b_col, { md: "6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_card_body, { title: "Document" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_card_text)
                          ], undefined, true),
                          _: 1
                        })
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_Loading)
          ]))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }))
}